<template>
      <el-dialog
    title="购买记录"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :append-to-body="true" 
    width="60%"
  >
  <div class="user">


    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
       

        <el-form-item label="">
          <el-input v-model="formInline.buser_search" placeholder="请输入购买人昵称"></el-input>
        </el-form-item>

        <el-form-item label="">
          <el-input v-model="formInline.order_search" placeholder="请输入订单编号/订单ID"></el-input>
        </el-form-item>



        <el-form-item>
          <el-button type="primary" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
            <el-table-column prop="user_achievement_conum_id" label="ID" > </el-table-column>
            <el-table-column prop="user.nickName" label="购买人" > </el-table-column>    
            <el-table-column prop="order.order_no" label="订单号" > </el-table-column>
            <el-table-column prop="create_time" label="购买时间" width="150"></el-table-column>
            <el-table-column fixed="right" label="操作" width="90">
              <template slot-scope="scope">
                <el-button @click="editClick(scope.row)" type="text" size="small" v-auth="'/order/order/detail'">订单详情</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background :current-page="curPage"
           :page-size="pageSize" layout="total, prev, pager, next, jumper"
          :total="totalDataNumber">
        </el-pagination>
      </div>
    </div>
  </div>
</el-dialog>
</template>

<script>
import uacApi from '@/api/uac.js';
export default {
  components: {},
  inject: ['reload'],
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*搜索表单对象*/
      form: {},
      /*当前编辑的对象*/
      userModel: {},
      formInline: {
        buser_search:"",
        order_search:"",
        user_search:"",
        is_settled:-1,
      },


    };
  },
  created() {
    this.dialogVisible = this.open_edit;
    this.getTableList();
  },
  props: ["open_edit","user_achievement_cnum_id"],
  methods: {

     /*关闭弹窗*/
     dialogFormVisible(result) {
      this.$emit("close", {});
    },
    cancelFunc(){//取消
      this.dialogFormVisible("error")
    },

    /*选择第几页*/
    handleCurrentChange(val) {
      this.curPage = val;
      this.getTableList();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getTableList();
    },
    editClick(row){
      let self = this;
      let params = row.order.order_id;
      self.$router.push({
        path: '/order/order/Detail',
        query: {
          order_id: params
        }
      });
    },
    /*获取列表*/
    getTableList() {
      let self = this;
      console.log("------")
      let Params = this.formInline;
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      self.loading = true;
      Params.user_achievement_cnum_id = self.user_achievement_cnum_id;
      uacApi.record(Params, true)
        .then(data => {
          self.loading = false;
          self.tableData = data.data.list.data;
          self.totalDataNumber = data.data.list.total;
        })
        .catch(error => {});
    },

    /*搜索查询*/
    onSubmit() {
      this.curPage = 1;
      this.getTableList();
    },



  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/uac/index/record.vue